import { Box, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useWindowSize } from 'react-use';
import Button from '~/components/Button';

import { Modal } from '../Modal';
import { DayPickerRangeControllerWrapper } from './DayPickerRangeControllerWrapper';
import { DATE_FORMAT, END_DATE, START_DATE } from './constants';

const propTypes = {
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  onDatesChange: PropTypes.func.isRequired,
  controllerProps: PropTypes.object,
  onClear: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  focusedInput: PropTypes.string,
  onFocusedInputChange: PropTypes.func.isRequired,
  hasDateSet: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  mainButton: PropTypes.node.isRequired,
};

/* eslint-disable react/prop-types */
const SelectionButtons = ({ isFocused: _isFocused, ...props }) => (
  <Button
    _hover={{
      borderColor: 'primary.500',
    }}
    borderColor="gray.200"
    fontSize="sm"
    fontWeight="normal"
    justifyContent="flex-start"
    letterSpacing="0"
    marginBottom="4"
    minWidth="40"
    textAlign="left"
    textTransform="none"
    variant="no-background"
    width="48%"
    {...props}
  />
);
/* eslint-enable react/prop-types */

const PreText = (props) => <Text color="gray.500" marginRight={2} {...props} />;

// default is 38
const getDaySize = (width) => {
  if (width > 320) {
    return undefined;
  }
  if (width <= 350) {
    return undefined;
  }

  return Math.floor((width - 40) / 7);
};

export const MobileDatePicker = ({
  startDate,
  endDate,
  controllerProps,
  onClear,
  onApply,
  onDateChange,
  focusedInput,
  onFocusedInputChange,
  hasDateSet,
  isOpen,
  onClose,
  mainButton,
}) => {
  const { width } = useWindowSize();

  const daySize = getDaySize(width);

  return (
    <>
      {mainButton}
      <Modal isFullScreenOnMobile isOpen={isOpen} onClose={onClose}>
        <Modal.Header
          color="gray.500"
          fontSize="md"
          fontWeight="normal"
          title="Select Date:"
        />
        <Modal.Body>
          <Box height="420px">
            <DayPickerRangeControllerWrapper
              startDate={startDate}
              endDate={endDate}
              onDatesChange={onDateChange}
              focusedInput={focusedInput}
              onFocusChange={onFocusedInputChange}
              numberOfMonths={1}
              daySize={daySize}
              transitionDuration={0}
              {...controllerProps}
            />
          </Box>
          <Flex
            flexWrap="wrap"
            justifyContent="space-around"
            position="relative"
          >
            <SelectionButtons
              color={startDate ? 'secondary.500' : 'gray.400'}
              onClick={() => onFocusedInputChange(START_DATE)}
              aria-label="Select from date"
              isFocused={focusedInput === START_DATE}
            >
              <>
                <PreText>From</PreText>
                {startDate && startDate.format(DATE_FORMAT)}
              </>
            </SelectionButtons>
            <SelectionButtons
              color={endDate ? 'secondary.500' : 'gray.400'}
              onClick={() => onFocusedInputChange(END_DATE)}
              aria-label="Select to date"
              isFocused={focusedInput === END_DATE}
            >
              <>
                <PreText>To</PreText>
                {endDate && endDate.format(DATE_FORMAT)}
              </>
            </SelectionButtons>
          </Flex>
        </Modal.Body>
        <Modal.Footer alignItems="center" flexDirection="row-reverse">
          <Button
            onClick={() => {
              onApply();
              onClose();
            }}
            colorScheme="secondary"
            aria-label="Apply date selection"
          >
            Apply
          </Button>
          {hasDateSet ? (
            <Button
              onClick={() => {
                onClear();
                onClose();
              }}
              variant="ghost"
              textTransform="none"
              letterSpacing="0"
            >
              Clear Selection
            </Button>
          ) : (
            <Button
              onClick={() => {
                onClose();
              }}
              variant="ghost"
              textTransform="none"
              letterSpacing="0"
            >
              Cancel
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

MobileDatePicker.propTypes = propTypes;
